export default __webpack_public_path__ + "static/media/cto-white.a10720bd.svg";